import LoginPage from 'app/pages/LoginPage';
import ForgotPasswordPage from 'app/pages/ForgotPasswordPage';
import ErrorPage from 'app/pages/ErrorPage';
import ThankYouPage from 'app/pages/ThankYouPage';
import VerifiedFailedPage from 'app/pages/VerifiedFailedPage';
import Iframe from 'app/module/micro-frontend/Iframe';
import EasyLogin from 'app/module/Authorization/EasyLogin';
import ForwardRedirect from 'app/module/ForwardRedirect';
import { isMobile } from 'react-device-detect';
import { Redirect } from 'react-router-dom';
import navigationsRoute from './navigationsRoute';
import qParams from './queryParamsVariables';
import LogoutPage from '../pages/LogoutPage';
import TrialWebView from '../pages/TrialWebView';
import RedirectAfterLogin from '../module/Authorization/RedirectAfterLogin';
import ModuleFederationApp from '../module/micro-frontend/ModuleFederationApp';

export interface IRoute {
  path: string;
  component: any;
  exact?: boolean;
  configurations: {
    to?: string;
    repositoryName?: string;
    tab?: string | null;
  };
}

const isWebView = window.localStorage.getItem('isMobile') === '1';

export const PermanentRoutes = [
  {
    path: `${navigationsRoute.EASY_LOGIN_BASE_URL}/:${qParams.email}/:${qParams.userId}/:${qParams.sessionToken}/:${qParams.deviceToken}`,
    exact: true,
    component: EasyLogin,
    configurations: {},
  },
];

export const NavRoutes: IRoute[] = [
  {
    path: '/dynamic-pricing',
    component: Redirect,
    exact: false,
    configurations: {
      to: navigationsRoute.DYNAMIC_PRICING,
    },
  },
  {
    path: '/calendar-mv/group-view',
    exact: true,
    component: Redirect,
    configurations: {
      to: navigationsRoute.CALENDAR,
    },
  },
  {
    path: '/',
    exact: true,
    component: RedirectAfterLogin,
    configurations: {},
  },
  {
    path: '/calendar/group-view',
    exact: true,
    configurations: {
      to: navigationsRoute.CALENDAR_MOBILE,
    },
    component: Redirect,
  },
  {
    path: navigationsRoute.IONIC_APP_HOME,
    exact: false,
    component: Iframe,
    configurations: {
      tab: 'Timeline',
    },
  },
  {
    path:
      isMobile && !isWebView
        ? navigationsRoute.CALENDAR_MOBILE
        : navigationsRoute.CALENDAR,
    exact: false,
    component: Iframe,
    configurations: {
      tab: 'Calendar',
    },
  },
  {
    path: '/tasks',
    exact: false,
    component: Iframe,
    configurations: {
      tab: 'Cleaning',
    },
  },
  {
    path: '/messaging',
    exact: false,
    component: Iframe,
    configurations: {
      tab: 'Messaging',
    },
  },
  {
    path: navigationsRoute.DAMAGE_PROTECTION,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-shield-page',
    },
  },
  // New Payment Processors page, added during the VRBO integration project.
  // This is the page that connects to the Guesty back end.
  {
    path: navigationsRoute.PAYMENT_PROCESSORS,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-payment-processors-page',
    },
  },
  // Integration page. Airbnb account onboarding
  {
    path: navigationsRoute.AIRBNB_ONBOARDING,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-airbnb-onboarding-page',
    },
  },
  // Integration page. Connection VRBO account flow
  {
    path: navigationsRoute.VRBO_INTEGRATION,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-vrbo-integration',
    },
  },
  {
    path: navigationsRoute.MARKUP_RATES,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-markup-rates',
    },
  },
  {
    path: navigationsRoute.BOOKING_INTEGRATION,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-booking-com',
    },
  },
  {
    path: navigationsRoute.ADD_NEW_RESERVATION_PAGE,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-add-new-reservation-page',
    },
  },
  {
    path: navigationsRoute.DYNAMIC_PRICING,
    exact: false,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'gfh-dynamic-pricing-page',
    },
  },
  // Smart lock flow
  {
    path: '/smart-locks/terms-and-conditions',
    exact: true,
    configurations: {
      to: `${navigationsRoute.SMART_LOCKS}/terms-and-conditions`,
    },
    component: Redirect,
  },
  {
    path: navigationsRoute.SMART_LOCKS,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'smart-locks-page',
    },
  },
  {
    path: navigationsRoute.GUESTY_CAPITAL,
    component: ModuleFederationApp,
    configurations: {
      repositoryName: 'add-ons-center-page/capital',
    },
  },
  {
    path: '/forward',
    exact: true,
    component: ForwardRedirect,
    configurations: {},
  },
  {
    path: '/more-menu',
    exact: false,
    component: Iframe,
    configurations: {
      tab: 'Menu',
    },
  },
  {
    path: navigationsRoute.TRIAL_WEB_VIEW,
    exact: true,
    component: TrialWebView,
    configurations: {},
  },
  {
    path: '/logout',
    component: LogoutPage,
    exact: true,
    configurations: {},
  },
];

export const AuthRoutes = [
  {
    path: navigationsRoute.LOGIN_PAGE,
    component: LoginPage,
    exact: true,
    configurations: {},
  },
  {
    path: navigationsRoute.FORGOT_PASSWORD,
    component: ForgotPasswordPage,
    exact: true,
    configurations: {},
  },
  {
    path: '/verification-email-failed',
    component: VerifiedFailedPage,
    exact: true,
    configurations: {},
  },
  {
    path: navigationsRoute.VERIFIED_EMAIL_SUCCESS,
    component: ThankYouPage,
    exact: true,
    configurations: {},
  },
  {
    path: '/verification-email-expired',
    component: ErrorPage,
    exact: true,
    configurations: {},
  },
  {
    path: '**',
    component: Redirect,
    exact: false,
    configurations: {
      to: navigationsRoute.LOGIN_PAGE,
    },
  },
];
